import { useNavigate } from "react-router-dom";
import "./PosterCard.css";

function PosterCard({ item, type, large = false, onClick }) {
  const navigate = useNavigate();

  // 🔥 SMART IMAGE PICKER (movie + webseries)
  const image =
    item.posterUrl ??
    item.backdropUrl ??
    item.image ??
    item.thumbnail ??
    item.poster ??
    item.backdrop ??
    null;

  const handleCardClick = () => {
    // ✅ If modal click handler exists → open modal
    if (onClick) {
      onClick(item);
      return;
    }

    // ✅ Otherwise normal navigate
    navigate(`/${type}/${item.id}`);
  };

  const handleTrailerClick = (e) => {
    e.stopPropagation();
    if (item.trailerUrl) window.open(item.trailerUrl, "_blank");
  };

  const handleWatchNowClick = (e) => {
    e.stopPropagation();
    if (item.ottUrl) window.open(item.ottUrl, "_blank");
  };

  return (
    <div
      className={`poster-card ${large ? "cinematic" : ""}`}
      onClick={handleCardClick}
    >
      {/* IMAGE */}
      {image ? (
        <img
          src={image}
          alt={item.title}
          loading="lazy"
          referrerPolicy="no-referrer"
        />
      ) : (
        <div className="poster-placeholder">No Image</div>
      )}

      {/* CONTENT */}
      <div className="poster-overlay always-visible">
        <h4 className="poster-title">{item.title}</h4>

        <div className="poster-actions">
          
            <button className="btn trailer" onClick={handleTrailerClick}>
              ▶ Trailer
            </button>
          

          
            <button className="btn ott" onClick={handleWatchNowClick}>
              📺 Watch Now
            </button>
          
        </div>
      </div>
    </div>
  );
}

export default PosterCard;
